/* eslint-disable no-tabs */
export default {
  /**
	 * Group
	 */
  'CREATE_GROUP': 'CREATE_GROUP',
  'UPDATE_GROUP': 'UPDATE_GROUP',
  'DELETE_GROUP': 'DELETE_GROUP',
  'APPROVE_GROUP': 'APPROVE_GROUP',
  'REJECT_GROUP': 'REJECT_GROUP',
  /**
   * Menu
   */
  'UPDATE_MENU': 'UPDATE_MENU',
  /**
	 * ORGANIZATION
	 */
  'CREATE_ORGANIZATION': 'CREATE_ORGANIZATION',
  'UPDATE_ORGANIZATION': 'UPDATE_ORGANIZATION',
  'DELETE_ORGANIZATION': 'DELETE_ORGANIZATION',
  'APPROVE_ORGANIZATION': 'APPROVE_ORGANIZATION',
  'REJECT_ORGANIZATION': 'REJECT_ORGANIZATION',
  'RESTORE_ORGANIZATION': 'RESTORE_ORGANIZATION',
  'VIEW_USER_ORGANIZATION': 'VIEW_USER_ORGANIZATION',
  /**
	 * PERMISSION
	 */
  'CREATE_PERMISSION': 'CREATE_PERMISSION',
  'UPDATE_PERMISSION': 'UPDATE_PERMISSION',
  'DELETE_PERMISSION': 'DELETE_PERMISSION',
  'GROUP_PERMISSION': 'GROUP_PERMISSION',
  /**
	 * POSITION
	 */
  'CREATE_POSITION': 'CREATE_POSITION',
  'UPDATE_POSITION': 'UPDATE_POSITION',
  'DELETE_POSITION': 'DELETE_POSITION',
  'APPROVE_POSITION': 'APPROVE_POSITION',
  'REJECT_POSITION': 'REJECT_POSITION',
  /**
	 * USER
	 */
  'CREATE_USER': 'CREATE_USER',
  'UPDATE_USER': 'UPDATE_USER',
  'DELETE_USER': 'DELETE_USER',
  'ACTIVATE_USER': 'ACTIVATE_USER',
  'DEACTIVATE_USER': 'DEACTIVATE_USER',
  'RESTORE_USER': 'RESTORE_USER',

  /**
	 * GROUPDOC
	 */
  'CREATE_GROUPDOC': 'CREATE_GROUPDOC',
  'UPDATE_GROUPDOC': 'UPDATE_GROUPDOC',
  'DELETE_GROUPDOC': 'DELETE_GROUPDOC',
  'VIEW_DOCUMENT_ORGANIZATION': 'VIEW_DOCUMENT_ORGANIZATION',
  'APPROVE_GROUPDOC': 'APPROVE_GROUPDOC',
  'REJECT_GROUPDOC': 'REJECT_GROUPDOC',
  /**
	 * DOCUMENT
	 */
  'CREATE_DOCUMENT': 'CREATE_DOCUMENT',
  'UPDATE_DOCUMENT': 'UPDATE_DOCUMENT',
  'DELETE_DOCUMENT': 'DELETE_DOCUMENT',
  'APPROVE_DOCUMENT': 'APPROVE_DOCUMENT',
  'REJECT_DOCUMENT': 'REJECT_DOCUMENT',
  /**
	 * DOCUMENT ITEM
	 */
  'CREATE_DOCUMENTITEM': 'CREATE_DOCUMENTITEM',
  'UPDATE_DOCUMENTITEM': 'UPDATE_DOCUMENTITEM',
  'DELETE_DOCUMENTITEM': 'DELETE_DOCUMENTITEM',
  'IMPORT_DOCUMENTITEM': 'IMPORT_DOCUMENTITEM',
  'UPDATE_INDEX_DOCUMENTITEM': 'UPDATE_INDEX_DOCUMENTITEM',

  /**
	 * GROUP CHECKLIST ITEM
	 */
  'CREATE_GROUPCHKITEM': 'CREATE_GROUPCHKITEM',
  'UPDATE_GROUPCHKITEM': 'UPDATE_GROUPCHKITEM',
  'DELETE_GROUPCHKITEM': 'DELETE_GROUPCHKITEM',
  'APPROVE_GROUPCHKITEM': 'APPROVE_GROUPCHKITEM',
  'REJECT_GROUPCHKITEM': 'REJECT_GROUPCHKITEM',
  'VIEW_CHECKLIST_ITEM': 'VIEW_CHECKLIST_ITEM',
  /**
	 * CHECKLIST ITEM
	 */
  'CREATE_CHECKLIST_ITEM': 'CREATE_CHECKLIST_ITEM',
  'UPDATE_CHECKLIST_ITEM': 'UPDATE_CHECKLIST_ITEM',
  'DELETE_CHECKLIST_ITEM': 'DELETE_CHECKLIST_ITEM',
  'APPROVE_CHECKLIST_ITEM': 'APPROVE_CHECKLIST_ITEM',
  'REJECT_CHECKLIST_ITEM': 'REJECT_CHECKLIST_ITEM',

  /**
	 * CHECKLIST ITEM STATUS
	 */
  'CREATE_CHKITEM_STATUS': 'CREATE_CHKITEM_STATUS',
  'UPDATE_CHKITEM_STATUS': 'UPDATE_CHKITEM_STATUS',
  'DELETE_CHKITEM_STATUS': 'DELETE_CHKITEM_STATUS',

  /**
	 * CHECKLIST ITEM TAG
	 */
  'CREATE_CHECKLIST_ITEM_TAG': 'CREATE_CHECKLIST_ITEM_TAG',
  'UPDATE_CHECKLIST_ITEM_TAG': 'UPDATE_CHECKLIST_ITEM_TAG',
  'DELETE_CHECKLIST_ITEM_TAG': 'DELETE_CHECKLIST_ITEM_TAG',

  /**
	 * CHECKLIST
	 // eslint-disable-next-line no-tabs
	 // eslint-disable-next-line no-tabs
	 */
  'CREATE_CHECKLIST': 'CREATE_CHECKLIST',
  'UPDATE_CHECKLIST': 'UPDATE_CHECKLIST',
  'DELETE_CHECKLIST': 'DELETE_CHECKLIST',
  'APPROVE_CHECKLIST': 'APPROVE_CHECKLIST',
  'REJECT_CHECKLIST': 'REJECT_CHECKLIST',
  'INPROGRESS_CHECKLIST': 'IN_PROGRESS_CHECKLIST',
  'CORRECTIVE_CHECKLIST': 'CORRECTIVE_CHECKLIST',
  'CLOSE_CHECKLIST': 'CLOSE_CHECKLIST',
  'DUPLICATE_CHECKLIST': 'DUPLICATE_CHECKLIST',
  'QREPORT_CHECKLIST': 'QREPORT_CHECKLIST',
  'VIEW_ALL_CHECKLIST': 'VIEW_ALL_CHECKLIST',
  'VIEW_ORG_CHECKLIST': 'VIEW_ORG_CHECKLIST',
  'ADD_CHECKLIST_ITEM': 'ADD_CHECKLIST_ITEM',
  'REMOVE_CHECKLIST_ITEM': 'REMOVE_CHECKLIST_ITEM',
  'EXPORT_MINUTES': 'EXPORT_MINUTES',
  /**
	 * COMMENT
	 */
  'CREATE_COMMENT': 'CREATE_COMMENT',
  'UPDATE_COMMENT': 'UPDATE_COMMENT',
  'DELETE_COMMENT': 'DELETE_COMMENT',
  'FINAL_COMMENT': 'FINAL_COMMENT',
  'SET_CORRECTIVE_STATUS': 'SET_CORRECTIVE_STATUS',
  'SET_CORRECTIVE_DATE': 'SET_CORRECTIVE_DATE',
  /**
	 * GROUP_ALIAS
	 */
  'CREATE_GROUP_ALIAS': 'CREATE_GROUP_ALIAS',
  'UPDATE_GROUP_ALIAS': 'UPDATE_GROUP_ALIAS',
  'DELETE_GROUP_ALIAS': 'DELETE_GROUP_ALIAS',

  /**
	 * HASHTAG
	 */
  'CREATE_HASHTAG': 'CREATE_HASHTAG',
  'UPDATE_HASHTAG': 'UPDATE_HASHTAG',
  'DELETE_HASHTAG': 'DELETE_HASHTAG',
  'ATTACH_HASHTAG': 'ATTACH_HASHTAG',

  /**
	 * GROUP_FAQ
	 */
  'CREATE_GROUP_FAQ': 'CREATE_GROUP_FAQ',
  'UPDATE_GROUP_FAQ': 'UPDATE_GROUP_FAQ',
  'DELETE_GROUP_FAQ': 'DELETE_GROUP_FAQ',
  'APPROVE_GROUP_FAQ': 'APPROVE_GROUP_FAQ',
  'REJECT_GROUP_FAQ': 'REJECT_GROUP_FAQ',
  /**
	 * FAQ
	 */
  'CREATE_FAQ': 'CREATE_FAQ',
  'UPDATE_FAQ': 'UPDATE_FAQ',
  'DELETE_FAQ': 'DELETE_FAQ',
  'CLOSE_FAQ': 'CLOSE_FAQ',
  'OPEN_FAQ': 'OPEN_FAQ',

  /**
	 * FAQ CMT
	 */
  'CREATE_FAQ_CMT': 'CREATE_FAQ_CMT',
  'UPDATE_FAQ_CMT': 'UPDATE_FAQ_CMT',
  'DELETE_FAQ_CMT': 'DELETE_FAQ_CMT',
  /**
 * CHECKLIST CATEGORY
 */
  'CREATE_CHK_CATEGORY': 'CREATE_CHK_CATEGORY',
  'UPDATE_CHK_CATEGORY': 'UPDATE_CHK_CATEGORY',
  'DELETE_CHK_CATEGORY': 'DELETE_CHK_CATEGORY',
  'SELECT_CHK_CATEGORY': 'SELECT_CHK_CATEGORY',
  /**
 * MEDIA
 */
  'GET_MEDIA': 'GET_MEDIA',
  'DELETE_MEDIA': 'DELETE_MEDIA',
  'DOCUMENT_MANAGER': 'DOCUMENT_MANAGER',
  'DELETE_DOCUMENT_MANAGER': 'DELETE_DOCUMENT_MANAGER',
  'GET_TRASH_MEDIA': 'GET_TRASH_MEDIA',
  'DESTROY_TRASH_MEDIA': 'DESTROY_TRASH_MEDIA',
  'RESTORE_TRASH_MEDIA': 'RESTORE_TRASH_MEDIA'
}



// WEBPACK FOOTER //
// ./src/permission.js